'use es6';

export const INVALID_CHARS = Object.freeze(['#', '?', '&', "'", '"', ';', ':', '*', '^', '!', '$', '|', '/', '\\', '%', '@', '<', '>', '[', ']', '=', ',', '(', ')', '~', '`', '{', '}', '+']);
export const INVALID_DOT_CHAR = '.';
export const INVALID_CHARS_DOT_ALLOWED_REGEX = new RegExp(INVALID_CHARS.map(char => `\\${char}`).join('|'), 'g');
export const INVALID_CHARS_REGEX = new RegExp(INVALID_CHARS_DOT_ALLOWED_REGEX.source.concat(`|\\${INVALID_DOT_CHAR}`), 'g');